import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CallbackPage } from "@/auth/CallbackPage";
import { SilentRenewPage } from "@/auth/SilentRenewPage";
import { HostingShell } from "@/features/shell/HostingShell";
import { SitesPage } from "@/pages/SitesPage";
import { NewSitePage } from "@/pages/NewSitePage";
import { SiteDetailPage } from "@/pages/SiteDetailPage";

function ProtectedShell() {
    return (
        <ProtectedRoute>
            <HostingShell />
        </ProtectedRoute>
    );
}

export function App() {
    return (
        <>
            <Routes>
                <Route path="/auth/callback" element={<CallbackPage />} />
                <Route path="/auth/silent-renew" element={<SilentRenewPage />} />
                <Route element={<ProtectedShell />}>
                    <Route path="/" element={<SitesPage />} />
                    <Route path="/new" element={<NewSitePage />} />
                    <Route path="/sites/:id" element={<SiteDetailPage />} />
                </Route>
            </Routes>
            <AppCopyright />
        </>
    );
}

function AppCopyright() {
    return (
        <div className="pointer-events-none fixed bottom-1 right-2.5 z-[9999] select-none text-[10px] leading-none text-muted-foreground/60">
            © {new Date().getFullYear()} Athavita Software Private Limited
        </div>
    );
}
